import MuiStepper, { StepperProps } from '@mui/material/Stepper';

/**
 * https://material-ui.com/components/steppers/#stepper
 */
const EDStepper = (props: StepperProps) => {
  return <MuiStepper {...props} />;
};

export default EDStepper;
